export default __webpack_public_path__ + "static/media/photo--lg--chris-4.b4d41a53.jpg";